import { radius, spacings } from "@/assets/themes";
import {
  Block,
  Body14,
  Body16,
  Breadcrumb,
  Button,
  Icon,
  Link,
  List,
} from "@/components";
import { CardBase } from "@/components/Styles/Base";
import { useGetMemberships } from "@/modules/routes/dashboard-routes";
import {
  ACCOUNT_MEMBERSHIP_CANCEL_PATH,
  ACCOUNT_MEMBERSHIP_PATH,
  ACCOUNT_PAYMENT_METHODS_PATH,
} from "@/pages/dashboard/config/routes";
import PageTitle from "@/pages/dashboard/PageTitle";
import { formatCardNumber, formatDate } from "@/utils";
import polyglot from "@/utils/polyglot";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";
import { getPaymentMethodBadge } from "@/pages/common/payment-methods/utils";
import { PAYMENT_METHOD_ICON_WIDTH } from "@/pages/common/payment-methods/constants";
import MembershipAlerts from "../MembershipAlerts";
import MembershipLayout from "../MembershipLayout";

const ManageMembership = () => {
  const { data } = useGetMemberships();

  const activeCard =
    data?.mangopay_cards?.find(
      (card) => card.id === data?.membership?.mangopay_card_id
    ) || {};

  return (
    <MembershipLayout>
      <Block marginBottom={spacings.m}>
        <Breadcrumb>
          <Link to={ACCOUNT_MEMBERSHIP_PATH}>
            {polyglot.t("common.subscription")}
          </Link>
          <span>{polyglot.t("membership.manage")}</span>
        </Breadcrumb>
      </Block>
      <PageTitle>{polyglot.t("membership.manage")}</PageTitle>
      <List.Header>{polyglot.t("membership.your_subscription")}</List.Header>
      <CardBase
        flat
        light
        css={`
          overflow: hidden;
          padding: ${spacings.s} 0;
        `}
      >
        <Block marginX={spacings.s}>
          <MembershipAlerts
            disableRedirect
            state={data?.membership?.state}
            css={`
              border-radius: ${radius.m};
            `}
          />
        </Block>
        <List.Group>
          <List.Item
            withGutters
            LeftComponent={() => <Icon.Large name="credit-card" />}
            RightComponent={() => (
              <Body16 strong>{polyglot.toSmartCurrency(data?.membership?.price)}</Body16>
            )}
          >
            <Body16 strong>{polyglot.t("membership.next_payment")}</Body16>
            <Body14>
              {polyglot.t("membership.renewal_date", {
                date: formatDate(
                  data?.membership?.renewal_date,
                  "DD MMMM YYYY"
                ),
              })}
            </Body14>
          </List.Item>
          <List.Item
            withGutters
            RightComponent={() => (
              <Block display="flex" alignItems="center" gap={spacings.s}>
                <Button.Link
                  as={Link}
                  css={`
                    padding-left: 0;
                    padding-right: 0;
                  `}
                  to={ACCOUNT_PAYMENT_METHODS_PATH}
                >
                  {polyglot.t("common.edit")}
                </Button.Link>
              </Block>
            )}
            LeftComponent={
              activeCard
                ? () => (
                    <img
                      src={getPaymentMethodBadge(activeCard?.kind)}
                      alt=""
                      width={PAYMENT_METHOD_ICON_WIDTH}
                    />
                  )
                : undefined
            }
          >
            <Body16 strong>
              {formatCardNumber(activeCard?.alias) ||
                polyglot.t("payment_method.payment_card")}
            </Body16>
          </List.Item>
        </List.Group>
      </CardBase>
      <List.Header>{polyglot.t("membership.manage")}</List.Header>
      <CardBase
        flat
        light
        css={`
          overflow: hidden;
          padding: ${spacings.s} 0;
        `}
      >
        <List.Group>
          <List.Item
            withGutters
            as={NavLink}
            LeftComponent={() => <Icon.Large name="times-circle" />}
            to={ACCOUNT_MEMBERSHIP_CANCEL_PATH}
          >
            <Body16>{polyglot.t("membership.cancel")}</Body16>
          </List.Item>
        </List.Group>
      </CardBase>
    </MembershipLayout>
  );
};

export default ManageMembership;
